import { Controller } from "@hotwired/stimulus"
import { rrFetch } from "../utils/rr_fetch"

export default class extends Controller {
  static targets = ["marquee"]

  connect() {
    // Fade-in
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-5")
      this.element.classList.add("opacity-100", "translate-y-0")
    })

  }

  close() {
    rrFetch("/close-notification", {
      method: "GET",
      headers: {
        "X-Requested-With": "Turbo",
      },
      credentials: "same-origin",
    })
    this.element.classList.add("opacity-0", "translate-y-5")
    this.element.classList.remove("opacity-100", "translate-y-0")
    setTimeout(() => this.element.remove(), 300)
  }
}
